import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'

export enum Actions {
  UPSERT_INFORMAL_FEEDBACK_REQUESTS = 'UPSERT_INFORMAL_FEEDBACK_REQUESTS',
  UPSERT_INFORMAL_FEEDBACK_REQUEST = 'UPSERT_INFORMAL_FEEDBACK_REQUEST',
}

export function upsertInformalFeedbackRequests(informalFeedbackRequests: InformalFeedbackRequest[]) {
  return {
    type: Actions.UPSERT_INFORMAL_FEEDBACK_REQUESTS,
    payload: { informalFeedbackRequests },
  }
}

export function upsertInformalFeedbackRequest(informalFeedbackRequest: InformalFeedbackRequest) {
  return {
    type: Actions.UPSERT_INFORMAL_FEEDBACK_REQUEST,
    payload: { informalFeedbackRequest },
  }
}
